"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.complete_document_signing = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
/**
 * Complete document signing with FaceTec verification and location
 * This endpoint:
 * - Marks signer as completed
 * - Stores location and FaceTec verification data
 * - Updates document status if all signers complete
 * - Generates certificates for all signers
 * - Sends completion email notifications to ALL signers
 */
function complete_document_signing(request) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        const response = yield new api_1.API().apiPost({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: `document/${request.document_id}/complete`,
            content: {
                location: request.location,
                facetec_verified: request.facetec_verified,
                facetec_session_id: request.facetec_session_id,
                verification_status: request.verification_status,
            },
            authorization: `${token}`,
            customHeaders: request.facetec_session_token
                ? {
                    "x-facetec-session": request.facetec_session_token,
                }
                : undefined,
        });
        return response;
    });
}
exports.complete_document_signing = complete_document_signing;
